{
    "productDashboard": {
        "common": {
            "last": "Posledních",
            "for": "Za",
            "days": "dnů",
            "day": "den",
            "categories": "kategorie",
            "open": "Otevřeno",
            "inProgress": "Probíhá",
            "inProgressShort": "Probíhá",
            "resolved": "Vyřešeno",
            "clear": "Vymazat",
            "selected": "vybráno",
            "clearAllFilters": "Vymazat všechny filtry"
        },
        "shell": {
            "dataUpdated": "Data aktualizována",
            "latestTurn": "poslední interakce",
            "records": "záznamů",
            "ofData": "dat",
            "syncing": "Synchronizace…",
            "refresh": "↻ Aktualizovat data",
            "dataRefreshed": "Data byla aktualizována.",
            "syncFailed": "Synchronizaci se nepodařilo spustit.",
            "syncCompletedWithErrors": "Synchronizace dokončena s chybami:",
            "timeRangeAria": "Časové období",
            "overview": "Přehled",
            "myhelpData": "z dat MyHelp",
            "rangeLabel": "Rozsah",
            "rangeAria": "Vlastní časové období",
            "rangeFrom": "Od",
            "rangeTo": "Do",
            "rangeApplyAria": "Použít časové období",
            "rangeClearAria": "Vymazat časové období",
            "rangeSelectBoth": "Vyberte počáteční i koncové datum.",
            "rangeInvalidOrder": "Počáteční datum musí být před koncovým.",
            "rangeTooWide": "Vyberte rozsah do",
            "dateRangeCaption": "Časové období"
        },
        "overview": {
            "greetingMorning": "Dobré ráno",
            "greetingAfternoon": "Dobré odpoledne",
            "greetingEvening": "Dobrý večer",
            "greetingNight": "Dobrou noc",
            "subtitle": "Zde je přehled dění napříč vašimi produkty dnes.",
            "tabOverview": "Přehled",
            "tabActionsForYou": "Akce pro vás",
            "actionsTitle": "Akce pro vás",
            "actionsMeta": "Doporučené další kroky pro produktový tým",
            "kpiTotalQueries": "CELKEM DOTAZŮ",
            "kpiIncidentsRaised": "NAHLÁŠENÉ INCIDENTY (Od 10. září)",
            "kpiUpcoming": "PŘIPRAVOVANÁ FUNKCE",
            "kpiCallback": "ŽÁDOSTI O ZPĚTNÉ VOLÁNÍ (Od 10. září)",
            "kpiLiveChat": "ŽÁDOSTI O ŽIVÝ CHAT (Od 10. září)",
            "viewBreakdown": "Rozpis →",
            "viewAllIncidents": "Všechny incidenty →",
            "upcomingTitle": "Nová funkce již brzy",
            "upcomingSub": "Další přehledy o produktech jsou na cestě.",
            "topCategories": "Nejčastější kategorie dotazů",
            "viewAll": "Zobrazit vše →",
            "tipQueries": "Dotazy",
            "uniqueUsersTitle": "Unikátní uživatelé",
            "detailedView": "Podrobné zobrazení",
            "usersPerDay": "Unikátní uživatelé za den",
            "usersPerWeek": "Unikátní uživatelé za týden",
            "usersPerMonth": "Unikátní uživatelé za měsíc",
            "uniqueUsersTrendTooltipLead": "Porovnává",
            "uniqueUsersTrendTooltipConnector": "s",
            "kpiTooltips": {
                "totalQueries": "Celkový počet dotazů přijatých napříč všemi produkty ve vybraném časovém rozmezí.",
                "incidentsRaised": "Incidenty nahlášené z konverzací s chatbotem, rozdělené podle stavu.",
                "upcoming": "Nová funkce přehledu je na cestě — brzy se vraťte.",
                "callback": "Žádosti o zpětné volání odeslané uživateli, rozdělené podle jazyka.",
                "liveChat": "Žádosti o živý chat odeslané uživateli, rozdělené podle jazyka.",
                "feedbackCoverage": "Podíl celkových dotazů, u kterých byla poskytnuta zpětná vazba (👍 nebo 👎)."
            }
        },
        "totalQueries": {
            "title": "Přehled celkových dotazů",
            "queries": "dotazy",
            "vsPrior": "oproti předchozímu období",
            "chartTitle": "Dotazy podle kategorie",
            "breakdownTitle": "Rozpis podle kategorií",
            "thCategory": "KATEGORIE",
            "thQueries": "DOTAZY",
            "thShare": "PODÍL",
            "thDistribution": "ROZLOŽENÍ",
            "tipQueries": "Dotazy",
            "tipShare": "Podíl %",
            "searchPlaceholder": "Hledat",
            "matchesSuffix": "shod",
            "matchSuffix": "shoda"
        },
        "incidents": {
            "title": "Kategorie problémů",
            "incidents": "incidenty",
            "thId": "ID",
            "thIssue": "DOTAZ / PROBLÉM",
            "thCategory": "KATEGORIE",
            "thProduct": "PRODUKT",
            "thCompany": "SPOLEČNOST",
            "thSeverity": "ZÁVAŽNOST",
            "thStatus": "STAV",
            "empty": "V tomto období nejsou žádné incidenty MyHelp.",
            "severityHigh": "Vysoká",
            "severityMedium": "Střední",
            "severityLow": "Nízká",
            "incident": "incident",
            "breakdownTitle": "Rozpis podle kategorie",
            "thIncidents": "INCIDENTY",
            "thShare": "PODÍL",
            "thDistribution": "ROZLOŽENÍ",
            "searchPlaceholder": "Hledat",
            "matchesSuffix": "shod",
            "matchSuffix": "shoda"
        },
        "incidentCategory": {
            "titlePrefix": "Incidenty v",
            "loadError": "Nepodařilo se načíst incidenty.",
            "incident": "incident",
            "incidents": "incidenty",
            "closeAria": "Zavřít",
            "thDate": "DATUM",
            "empty": "Pro tuto kategorii nebyly nalezeny žádné incidenty.",
            "loading": "Načítání…",
            "loadMorePrefix": "Načíst další (zobrazeno",
            "of": "z"
        },
        "userSentiment": {
            "title": "Přehled zpětné vazby uživatelů",
            "summaryLikes": "líbí se mi",
            "summaryDislikes": "nelíbí se mi",
            "last": "Posledních",
            "days": "dnů",
            "likes": "Líbí se mi",
            "dislikes": "Nelíbí se mi",
            "chartTitle": "Líbí se mi vs. nelíbí se mi podle kategorie",
            "detailTitle": "Podrobná zpětná vazba podle kategorie",
            "positive": "Pozitivní",
            "thingsWell": "Co se povedlo",
            "thingsAttention": "Co vyžaduje pozornost",
            "askAiHint": "Zeptejte se AI asistenta (otevře se na nové kartě)",
            "searchPlaceholder": "Hledat",
            "matchesSuffix": "shod",
            "matchSuffix": "shoda"
        },
        "products": {
            "title": "Kategorie produktů",
            "products": "produkty",
            "queryVolume": "Objem dotazů",
            "incidents": "Incidenty",
            "sentiment": "Sentiment",
            "healthScore": "Skóre stavu"
        },
        "companyFilter": {
            "allCompanies": "Všechny společnosti",
            "allCompaniesShort": "Všechny společnosti",
            "selectedSuffix": "společností vybráno",
            "filterAria": "Filtrovat podle společnosti",
            "searchPlaceholder": "Hledat společnosti…",
            "noMatchPrefix": "Žádné společnosti neodpovídají"
        },
        "clusterFilter": {
            "allClusters": "Všechny klastry",
            "allClustersShort": "Všechny klastry",
            "selectedSuffix": "klastrů vybráno",
            "filterAria": "Filtrovat podle klastru",
            "searchPlaceholder": "Hledat klastry…",
            "noMatchPrefix": "Žádné klastry neodpovídají"
        },
        "categoryFilter": {
            "allCategories": "Všechny kategorie",
            "selectedSuffix": "kategorií vybráno",
            "filterAria": "Filtrovat podle kategorie",
            "searchPlaceholder": "Hledat kategorie…",
            "allCategoriesShort": "Všechny kategorie",
            "selectedShort": "vybráno",
            "clear": "Vymazat",
            "noMatchPrefix": "Žádné kategorie neodpovídají"
        },
        "categoryQueries": {
            "like": "Líbí se mi",
            "dislike": "Nelíbí se mi",
            "titlePrefix": "Dotazy v",
            "loadError": "Dotazy se nepodařilo načíst.",
            "query": "dotaz",
            "queries": "dotazy",
            "preparing": "Připravuje se…",
            "downloadExcel": "⬇ Stáhnout Excel",
            "closeAria": "Zavřít",
            "thQuery": "DOTAZ",
            "thSentiment": "SENTIMENT",
            "thDate": "DATUM",
            "thSource": "ZDROJ",
            "thLanguage": "JAZYK",
            "thCompany": "SPOLEČNOST",
            "colQuery": "Dotaz",
            "colSentiment": "Sentiment",
            "colDate": "Datum",
            "colSource": "Zdroj",
            "colLanguage": "Jazyk",
            "colCompany": "Společnost",
            "empty": "Pro tuto kategorii nebyly nalezeny žádné dotazy.",
            "loading": "Načítání…",
            "loadMorePrefix": "Načíst další (zobrazeno",
            "of": "z",
            "sortSentimentHint": "Klepnutím seřadíte podle sentimentu",
            "sortDateHint": "Klepnutím seřadíte podle data"
        },
        "feedbackPie": {
            "likes": "Líbí se mi",
            "dislikes": "Nelíbí se mi",
            "noFeedback": "Žádná zpětná vazba",
            "coverage": "POKRYTÍ ZPĚTNOU VAZBOU",
            "meta": "z celkových dotazů",
            "feedback": "zpětná vazba",
            "noData": "Žádná data",
            "viewFeedback": "Zpětnou vazbu uživatelů →"
        },
        "requestCard": {
            "empty": "V tomto období nejsou žádné požadavky.",
            "breakdown": "Rozpis →"
        },
        "requestBreakdown": {
            "titleCallback": "Žádosti o zpětné volaní — Rozpis podle jazyka",
            "titleLiveChat": "Žádosti o živý chat — Rozpis podle jazyka",
            "breakdownTitle": "Rozpis podle jazyka",
            "thLanguage": "JAZYK",
            "thCount": "POČET",
            "thShare": "PODÍL",
            "thDistribution": "ROZLOŽENÍ",
            "language": "jazyk",
            "languages": "jazyky",
            "request": "požadavek",
            "requests": "požadavky",
            "empty": "V tomto období nejsou žádné požadavky."
        },
        "tabError": {
            "title": "Data dashboardu se nepodařilo načíst",
            "message": "Datová služba neodpověděla. Zkuste to prosím znovu — nezobrazují se žádná data, takže zde nic není odhadováno."
        },
        "actionItems": {
            "knowledgeArticles": {
                "title": "Vytvořit / aktualizovat znalostní články",
                "hint": "Udržujte obsah vašeho produktu přesný a aktuální",
                "childTitle": "Vytvoření a aktualizace znalostní báze",
                "childHint": "Jak vytvořit a aktualizovat znalostní bázi."
            },
            "scripts": {
                "title": "Sestavit a nasadit skripty prostřednictvím Nexthink Remote Actions",
                "hint": "Automatizujte řešení problému povolením vzdálené akce na zařízení uživatele",
                "childTitle": "Odkaz na objednání Nexthink",
                "childHint": "Správa vzdálených akcí"
            }
        }
    }
}
